// extracted by mini-css-extract-plugin
export var bold = "title-module--bold--9oYuc";
export var light = "title-module--light--OjA10";
export var title = "title-module--title--ktbK2";